const ganeshData=[
    
    {
        imageUrl:"https://res.cloudinary.com/bazeercloud/image/upload/v1710826007/images/ganesh_kyfacn.jpg",
         itemName:" Ganpati Bappa",
          description:"Jaipur Marble Bappa Idol",
          size:"18 inch"
    },
    {
        imageUrl:"https://res.cloudinary.com/bazeercloud/image/upload/v1710826167/images/ganesh4_kxgwrk.jpg",
          itemName:" Ganpati Bappa",
          description:"Jaipur Marble Bappa Idol",
          size:"18 inch"
    },
    {
        imageUrl:"https://res.cloudinary.com/bazeercloud/image/upload/v1710823878/images/ganesh2_oggp0d.jpg",
        itemName:" Ganpati Bappa",
        description:"Jaipur Marble Bappa Idol",
        size:"18 inch"
    },
    {
        imageUrl:"https://res.cloudinary.com/bazeercloud/image/upload/v1710824243/images/ganesh3_ryk4cz.webp",
        itemName:" Ganpati Bappa",
        description:"Jaipur Marble Bappa Idol",
        size:"18 inch"
    },
    // -----------------Durga ----------------------------------------------
   {
    imageUrl:"https://res.cloudinary.com/bazeercloud/image/upload/v1710826773/images/durga3_sdjvzr.jpg",
    itemName:"Ma Durga",
    description:"Jaipur Marble Ma Durga Idol",
    size:"5 feet"
   },
   {
    imageUrl:"https://res.cloudinary.com/bazeercloud/image/upload/v1710827534/images/durga_ywyvyb.jpg",
    itemName:"Ma Durga",
    description:"Jaipur Marble Ma Durga Idol",
    size:"5 feet"
   },
   {
    imageUrl:"https://res.cloudinary.com/bazeercloud/image/upload/v1710828241/images/durga9_knhagl.jpg",
    itemName:"Ma Durga",
    description:"Jaipur Marble Ma Durga Idol",
    size:"5 feet"
   },
   {
    imageUrl:"https://res.cloudinary.com/bazeercloud/image/upload/v1710828443/images/durga10_bi8hxg.jpg",
    itemName:"Ma Durga",
     
    description:"Jaipur Marble Ma Durga Idol",
    size:"5 feet"
   },

// ------------------Sarswati---------------------------------------------------------
{
    imageUrl:"https://res.cloudinary.com/bazeercloud/image/upload/v1710862078/images/sarswati_gjonwl.jpg",
    itemName:"Ma Saraswati",
        description:"Jaipur Marble Ma Saraswati Idol",
    size:" 1.5 feet"
   },
   {
    imageUrl:"https://res.cloudinary.com/bazeercloud/image/upload/v1710862043/images/saraswati2_wsrhoq.webp",
    itemName:"Ma Saraswati",
        description:"Jaipur Marble Ma Saraswati Idol",
    size:"1.5 feet"
   },
   {
    imageUrl:"https://res.cloudinary.com/bazeercloud/image/upload/v1710862063/images/sarswati3_kinnii.jpg",
    itemName:"Ma Saraswati",
     
    description:"Jaipur Marble Ma Saraswati Idol",
    size:"3 feet"
   },
   {
    imageUrl:"https://res.cloudinary.com/bazeercloud/image/upload/v1710862041/images/saraswati_4_uu81od.webp",
    itemName:"Ma Saraswati",
     
    description:"Jaipur Marble Ma Saraswati Idol",
    size:"4 feet"
   },
//    -------------------------RamDarbar------------------------------
{
    imageUrl:"https://res.cloudinary.com/bazeercloud/image/upload/v1710863251/images/ramdarbar3_yerhtp.jpg",
    itemName:"Shri Ram Darbar",
    
    description:"Fine finishing with the grace of jaipur marble",
    size:" 1.5 feet"
   },
   {
    imageUrl:"https://res.cloudinary.com/bazeercloud/image/upload/v1710863277/images/ramdarbar4_p3yvwy.jpg",
    itemName:"Shri Ram Darbar",
    
    description:"Fine finishing with the grace of jaipur marble",
    size:" 1.5 feet"
   },
   {
    imageUrl:"https://res.cloudinary.com/bazeercloud/image/upload/v1710863250/images/ramdarbar2_dcwx6q.jpg",
    itemName:"Shri Ram Darbar",
    
    description:"Fine finishing with the grace of jaipur marble",
    size:" 1.5 feet"
   },
   {
    imageUrl:"https://res.cloudinary.com/bazeercloud/image/upload/v1710863249/images/ramdarbar_vklydl.jpg",
    itemName:"Shri Ram Darbar",
    
    description:"Fine finishing with the grace of jaipur marble",
    size:" 1.5 feet"
   },
];

export default ganeshData;